import React from 'react';
import DeviceList from './DeviceList';

class Dashboard extends React.Component {
  render() {
    return <DeviceList />;
  }
}

export { Dashboard };
